// src/api/auth.js
import { apiCall } from "@/api/client";
import { getNativeAuthReturnScheme } from "@/lib/nativeAppLinks";

export const requestPasswordReset = (email) =>
    apiCall("/api/auth/password/forgot", {
        method: "POST",
        body: JSON.stringify({
            email,
            native_return_scheme: getNativeAuthReturnScheme(),
        }),
    });

export const resetPassword = (token, newPassword) =>
    apiCall("/api/auth/password/reset", {
        method: "POST",
        body: JSON.stringify({ token, new_password: newPassword }),
    });
